import { IAppState } from '../root-reducer';

export const getHomepagePageRowsLoadingStatus = (state: IAppState) => state.layoutPage.homepage.isLoading;

export const getHomepagePageRows = (state: IAppState) => state.layoutPage.homepage.pageRows;

export const getHomepagePageRowsUrl = (state: IAppState) => state.layoutPage.homepage.url;

export const getHomepageLoadingStatus = (state: IAppState) => state.layoutPage.homepage.isLoading;

export const getHomepageUsp = (state: IAppState) => state.layoutPage.homepage.homepageUsp;

export const getPageRowsSeoDescription = (state: IAppState) => state.layoutPage.otherLayoutPage.seoDescription;
export const getPageRowsHomeSeoDescription = (state: IAppState) => state.layoutPage.homepage.seoDescription;

export const getModulePageState = (state: IAppState) => state.layoutPage.otherLayoutPage;

export const getModulePageRows = (state: IAppState) => state.layoutPage.otherLayoutPage.pageRows;

export const getModulePageRowsTitle = (state: IAppState) => state.layoutPage.otherLayoutPage.title;
